require('../../modules/es.number.is-nan');
var path = require('../../internals/path');

module.exports = path.Number.isNaN;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/number/is-nan.js
// module id = 1219
// module chunks = 1